
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'

const WEEKDAYS = [
    'ПН',
    'ВТ',
    'СР',
    'ЧТ',
    'ПТ',
    'СБ',
    'ВС',
]

export default defineComponent({
    props: {
        resources: {
            type: Array as PropType<{ weekday: number; amount: number; }[]>,
            default: () => []
        }
    },
    setup(props) {
        const resourcesArray = computed(() => {
            const resources: { weekday: number; amount: number; }[] = [...props.resources]
            const first = resources[0]

            resources.splice(0, 1)
            resources.push(first as { weekday: number; amount: number; })
            
            return resources
        })

        return {
            WEEKDAYS,
            resourcesArray
        }
    }
})
